import api from "../config/api";

import {
  ServicePaginatedReturn,
  ServiceReturn,
} from "../types/ServiceResponse";

import { Contact } from "../models/Contact";
import { ContactForm } from "../schemas/contactSchema";
import { removeUnwantedCharacters } from "../helpers/phoneHelper";

export interface GetContactsPayload {
  page?: number;
  perPage?: number;
  search?: string;
};

export interface SearchContactsPayload {
  search: string;
};

const moduleBaseUrl = "contact";

export const saveContact = async ( contact: ContactForm, token?: string ): Promise<ServiceReturn<boolean>> => {
  try {
    delete contact.id;


    contact.phone = removeUnwantedCharacters(`${ contact.ddi.code }${ contact.phone }`);

    const {
      data
    } = await api.post(`/${ moduleBaseUrl }`, contact, {
      headers: {
        Authorization: `Bearer ${ token }`,
      }
    });

    return data;
  } catch ( error: any ) {
    return {
      data: false,
      message: error?.response?.data?.message ?? error?.message,
    };
  }
};

export const getContacts = async ({ page = 1, perPage = 10, search }: GetContactsPayload, token?: string ): Promise<ServicePaginatedReturn<Contact>> => {
  try {
    const {
      data
    } = await api.get(`/${ moduleBaseUrl }`, {
      headers: {
        Authorization: `Bearer ${ token }`,
      },
      params: {
        page,
        perPage,
        search,
      }
    });

    return data;
  } catch ( error: any ) {
    return {
      data: false,
      message: error?.response?.data?.message ?? error?.message,
    };
  }
};

export const searchContacts = async (params: SearchContactsPayload, token?: string ): Promise<ServiceReturn<Array<Contact>>> => {
  try {

    const {
      data
    } = await api.get(`/${ moduleBaseUrl }/search`, {
      headers: {
        Authorization: `Bearer ${ token }`,
      },
      params,
    });

    return data;
  } catch ( error: any ) {
    return {
      data: false,
      message: error?.response?.data?.message ?? error?.message,
    };
  }
};

export const updateContact = async ( contact: ContactForm, token?: string ): Promise<ServiceReturn<boolean>> => {
  try {
    contact.phone = removeUnwantedCharacters(`${ contact.ddi.code }${ contact.phone }`);

    const {
      data
    } = await api.put(`/${ moduleBaseUrl }/${ contact.id }`, contact, {
      headers: {
        Authorization: `Bearer ${ token }`,
      }
    });

    return data;
  } catch ( error: any ) {
    return {
      data: false,
      message: error?.response?.data?.message ?? error?.message,
    };
  }
};

export const deleteContact = async ( id: string, token?: string ): Promise<ServiceReturn<boolean>> => {
  try {
    const {
      data
    } = await api.delete(`/${ moduleBaseUrl }/${ id }`, {
      headers: {
        Authorization: `Bearer ${ token }`,
      }
    });

    return data;
  } catch ( error: any ) {
    return {
      data: false,
      message: error?.response?.data?.message ?? error?.message,
    };
  }
};
